export default __webpack_public_path__ + "static/media/documents_transporters.bf8804f9.png";